export default function copyVideoLink () {
  const elVideoShareButton = document.querySelector('.VideoPlayerShare-button')
  if (elVideoShareButton) {

    elVideoShareButton.addEventListener('click', (e) => {
      e.preventDefault()
      const linkToCopy = document.createElement('textarea')
      linkToCopy.value = document.querySelector('.VideoPlayerShare-text').value
      document.body.appendChild(linkToCopy)
      linkToCopy.select()
      document.execCommand('copy')
      document.body.removeChild(linkToCopy)
      const width = elVideoShareButton.offsetWidth
      elVideoShareButton.parentNode.classList.add('VideoPlayerShare--copied')
      elVideoShareButton.style.width = width + 'px'
      elVideoShareButton.textContent = "Länk kopierad!"
      const t = setTimeout(() => {
        elVideoShareButton.parentNode.classList.remove('VideoPlayerShare--copied')
        elVideoShareButton.textContent = "Kopiera video-länk"
        elVideoShareButton.style.width = 'auto'
      }, 2000)
    })
  } else {
    return
  }
}
